import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // console.log("Modal controller connected to", this.element)

    // // Debug any data attributes
    // console.log("Data attributes:", {
    //   modalId: this.element.dataset.modalId,
    //   action: this.element.dataset.action
    // })
  }

  open(event) {
    // First, ensure all modals are hidden
    document.querySelectorAll('[id$="Modal"]').forEach(m => {
      m.style.display = 'none'
      m.classList.add('hidden')
    })

    const modalId = this.element.dataset.modalId
    if (modalId) {
      const modal = document.getElementById(modalId)
      if (modal) {
        modal.classList.remove('hidden')
        modal.style.display = 'block'

        // Make sure the inner container is properly displaying as flex
        const innerContainer = modal.querySelector('div')
        if (innerContainer) {
          innerContainer.style.display = 'flex'
        }
      } else {
        console.error("Modal with ID not found:", modalId)
      }
    } else {
      console.error("No modal ID specified on element:", this.element)
    }
  }

  close(event) {
    // console.log("Close method called", event)

    // Find the parent modal container
    const modal = this.element.closest('[id$="Modal"]')
    if (modal) {
      // console.log("Found modal to close:", modal)
      modal.style.display = 'none'
      modal.classList.add('hidden')
    } else {
      console.error("No modal found to close")
    }
  }
}
